import Icon from '@mui/icons-material/NewReleases';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

const LeadDuplicateStatus = ({ lead }) => {
  const isDuplicate = lead.is_duplicate_email;
  if (!isDuplicate) return null;
  return (
    <Tooltip title={'This lead has the same email address as another lead!'}>
      <Icon style={{fontSize: '1.1rem'}} color='error' />
      <Typography color='error' variant='body2'>Duplicate</Typography>
    </Tooltip>
  );
};

export default LeadDuplicateStatus;